import { analytics } from '../config/firebase';
import { logEvent } from 'firebase/analytics';

/**
 * Track SPA Page Views across Google Analytics 4 & Firebase
 * @param {string} path - URL pathname (e.g. /shop, /cart, /product/123)
 * @param {string} [title] - Optional document title
 */
export const trackPageView = (path, title = '') => {
  try {
    const pagePath = path || window.location.pathname;
    const pageTitle = title || document.title;

    // 1. Google Analytics gtag.js
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: pagePath,
        page_title: pageTitle,
        page_location: window.location.href
      });
    }

    // 2. Firebase Analytics SDK
    if (analytics) {
      logEvent(analytics, 'page_view', {
        page_path: pagePath,
        page_title: pageTitle
      });
    }
  } catch (err) {
    // Non-blocking analytics error
  }
};

/**
 * Track Custom Events (e.g. clicks, searches, filters)
 */
export const trackEvent = (eventName, params = {}) => {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }
    if (analytics) {
      logEvent(analytics, eventName, params);
    }
  } catch (err) {
    // Non-blocking
  }
};

/**
 * Track E-Commerce: View Item (Product Detail Page)
 */
export const trackViewItem = (product) => {
  if (!product) return;
  trackEvent('view_item', {
    currency: 'INR',
    value: product.price || 0,
    items: [
      {
        item_id: product._id || product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price
      }
    ]
  });
};

/**
 * Track E-Commerce: Add To Cart
 */
export const trackAddToCart = (product, quantity = 1, size = '', color = '') => {
  if (!product) return;
  trackEvent('add_to_cart', {
    currency: 'INR',
    value: (product.price || 0) * quantity,
    items: [
      {
        item_id: product._id || product.id,
        item_name: product.name,
        item_category: product.category,
        price: product.price,
        quantity,
        item_variant: [size, color].filter(Boolean).join(' / ')
      }
    ]
  });
};

/**
 * Track E-Commerce: Purchase
 */
export const trackPurchase = (orderId, total, items = []) => {
  trackEvent('purchase', {
    transaction_id: orderId,
    value: total,
    currency: 'INR',
    items: items.map(item => ({
      item_id: item.product?._id || item.product?.id || item._id,
      item_name: item.product?.name || item.name,
      price: item.product?.price || item.price,
      quantity: item.quantity || 1
    }))
  });
};

export default {
  trackPageView,
  trackEvent,
  trackViewItem,
  trackAddToCart,
  trackPurchase
};
